import { h } from '@stencil/core';
export const CO2Message = ({ co2message }) => {
  return h("div", { class: "co2-message" }, h("qds-icon", { name: "box-arrow-clockwise", class: "co2-message__icon" }), h("span", { class: "co2-message__label", innerHTML: co2message }));
};
